import { NotificationCard } from '../../components/Card';
import { MeetingContainer } from './MeetingContainer';
import { FaRegCalendarTimes } from 'react-icons/fa';
import { LuCalendarPlus } from 'react-icons/lu';

export const MeetingCancelled = ({ notification = {}, onClose = () => {} }) => {
  return (
    <NotificationCard notification={notification}>
      <MeetingContainer
        notification={notification}
        onClose={onClose}
        type="cancelled"
        icon={FaRegCalendarTimes}
        iconColor="#CD5C5C"
        iconbg="#FFE3E3"
      />
    </NotificationCard>
  );
};

export const MeetingBooked = ({ notification = {}, onClose = () => {} }) => {
  return (
    <NotificationCard notification={notification}>
      <MeetingContainer
        notification={notification}
        onClose={onClose}
        type="booked"
        icon={LuCalendarPlus}
        iconColor="#605AFB"
        iconbg="#F4F4FB"
        showButton={true}
      />
    </NotificationCard>
  );
};

export const CandidateMeetingBooked = ({
  notification = {},
  onClose = () => {},
}) => {
  return (
    <NotificationCard notification={notification}>
      <MeetingContainer
        notification={notification}
        onClose={onClose}
        type="candidateBooked"
        icon={LuCalendarPlus}
        iconColor="#605AFB"
        iconbg="#F4F4FB"
        showButton={true}
      />
    </NotificationCard>
  );
};

export const MeetingStartingSoon = ({
  notification = {},
  onClose = () => {},
}) => {
  return (
    <NotificationCard notification={notification}>
      <MeetingContainer
        notification={notification}
        onClose={onClose}
        type="startingSoon"
        icon={LuCalendarPlus}
        iconColor="#605AFB"
        iconbg="#F4F4FB"
        showButton={true}
      />
    </NotificationCard>
  );
};

export const MeetingReschedule = ({
  notification = {},
  onClose = () => {},
}) => {
  return (
    <NotificationCard notification={notification}>
      <MeetingContainer
        notification={notification}
        onClose={onClose}
        type="reschedule"
        icon={LuCalendarPlus}
        iconColor="#605AFB"
        iconbg="#F4F4FB"
        showButton={true}
      />
    </NotificationCard>
  );
};

export const RsvpReminder = ({ notification = {}, onClose = () => {} }) => {
  return (
    <NotificationCard notification={notification}>
      <MeetingContainer
        notification={notification}
        onClose={onClose}
        type="rsvpReminder"
        icon={LuCalendarPlus}
        iconColor="#605AFB"
        iconbg="#F4F4FB"
        showButton={false}
      />
    </NotificationCard>
  );
};

export const RsvpReminderNotification = ({
  notification = {},
  onClose = () => {},
}) => {
  return (
    <NotificationCard notification={notification}>
      <MeetingContainer
        notification={notification}
        onClose={onClose}
        type="rsvpReminderNotification"
        icon={LuCalendarPlus}
        iconColor="#605AFB"
        iconbg="#F4F4FB"
        showButton={false}
      />
    </NotificationCard>
  );
};
